import React from 'react'
import PropTypes from 'prop-types'

import * as firebase from 'firebase'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import Paper from 'material-ui/Paper'
import Popover from 'material-ui/Popover'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import CircularProgress from 'material-ui/CircularProgress'

import JobModuleCard from './modules/JobModuleCard'
import JobModulesDivider from './modules/JobModulesDivider'
import ModulesConfig from './modules/ModulesConfig'
import ModulesUtils from '../../infra/ModulesUtils'
import FunctionUtils from '../../lambda/FunctionUtils'
import CustomerUtils from 'customer/Utils'
import Analytics from 'infra/analytics/Analytics'

import './modules/styles.css'
import closeIcon from 'resources/close_icon.png'

const DELETE_INSTANCE = 'DELETE_INSTANCE'
const DELETE_FUTURE = 'DELETE_FUTURE'
const DELETE_ALL = 'DELETE_ALL'

const Header = ({ title, onCloseClicked }) => {
  return (
    <div style={headerStyle}>
      <div style={headingStyle}>
        { title }
      </div>
      <div style={{ marginRight: 32 }}>
        <img src={closeIcon} title='Close' width={16}
          onClick={onCloseClicked}
          style={{ cursor: 'pointer' }} />
      </div>
    </div>
  )
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  onCloseClicked: PropTypes.func.isRequired
}

class JobScreen extends React.Component {

  static propTypes = {
    dateStr: PropTypes.string,
    jobInfo: PropTypes.object,
    teamId: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state = {
      openDialog: false,
      loading: false,
      isTablet: FunctionUtils.isUserOnTablet(),
      deleteType: undefined,
      openPopover: false,
      openLineItemsDetails: false,
      openShowAllPhotosScreen: false,
      openShowAllMaterialsScreen: false,
      openShowAllNotesScreen: false
    }
    this.listener = this.onUpdate.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
  }

  getDateStr() {
    let dateStr = this.props.dateStr
    if (!dateStr) {
      dateStr = this.state.jobInfo.modules.date.startDate
    }
    return dateStr
  }

  getModuleRecurrenceTypeInfo() {
    return this.state.jobInfo.modules.date.recurrence
  }

  isNewJob(jobInfo) {
    if (jobInfo) {
      return !jobInfo.id
    }
    return !this.props.jobInfo.id
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.jobInfo === this.props.jobInfo) {
      return
    }

    if (this.props.jobInfo && !nextProps.jobInfo){
      //Jobscreen is closing
      this.setState({ jobInfo: undefined })
    }

    if (this.props.jobInfo) {
      this.detachLoaders()
    }

    if (nextProps.jobInfo) {
      this.initLoaders(nextProps.jobInfo)
    }
  }

  componentWillUnmount() {
    this.detachLoaders()
  }

  initLoaders(jobInfoProps) {
    const jobInfo = Object.assign({}, jobInfoProps)

    const isNewJob = this.isNewJob(jobInfo)
    if (isNewJob) {
      const newId = firebase.database().ref('events').push().key
      jobInfo.id = newId
    }
    this.dbPath = `events/${jobInfo.id}/commonInfo`
    this.extendedPath = `events/${jobInfo.id}/extendedInfo`
    if (isNewJob) {
      firebase.database().ref(this.dbPath).set(jobInfo)
    }

    //notify loading
    this.setState({loading: true})

    // Start querying and listening for changes
    firebase.database().ref(this.dbPath).on('value', this.listener)
  }

  detachLoaders() {
    firebase.database().ref(this.dbPath).off('value', this.listener);
  }

  onUpdate(snapshot) {
    let value = snapshot.val();
    if (!value) {
      value = {}
      // Job moved
      if (this.state.loaded) {
        this.handleClose()
        return
      }
    }
    // Prepare modules
    this.modules = [];
    for (const key in value.modules) {
      if (!value.modules.hasOwnProperty(key)) {
        continue
      }
      this.modules.push(key)
    }
    ModulesUtils.sortModules(this.modules)
    this.setState({jobInfo: value, loading: false})
  }

  validateJobInfo = () => {
    const modules = this.state.jobInfo && this.state.jobInfo.modules
    const nameModule = modules && modules.displayName
    if (!nameModule || !nameModule.value) {
      return { error: 'Please enter a name for the job.' }
    }
    const workersModule = modules && modules.workers
    if (!workersModule || !workersModule.list || !_.size(workersModule.list)) {
      return { error: 'Please assign at least one crew to the job.' }
    }
    return { success: true }
  }

  handleCreate() {
    const validationResult = this.validateJobInfo()
    if (validationResult.success) {
      FunctionUtils.createJob(this.props.teamId, this.state.jobInfo)
      this.handleClose()
      ModulesUtils.showSnackbar('Your job was created')
      const type = FunctionUtils.getJobType(this.state.jobInfo)
      Analytics.track(Analytics.EVENT_CREATED_DASHBOARD, { type })
    }
    else {
      ModulesUtils.showSnackbar(validationResult.error)
    }
  }

  handleDelete(event) {
    this.dialogCallbackYes = () => {
      // Remove data
      const deleteType = this.state.deleteType;
      if (deleteType === DELETE_INSTANCE) {
        this.deleteInstance();
      } else if (deleteType === DELETE_FUTURE) {
        this.deleteFutureInstances();
      } else if (deleteType === DELETE_ALL) {
        this.deleteAllInstances();
      } else {
        // Remove temporal data
        FunctionUtils.deleteJob(this.props.teamId, this.state.jobInfo);
      }
      this.setState({openDialog: false});
      this.handleClose();
    };
    this.dialogCallbackNo = () => {
      this.setState({openDialog: false});
    };
    if (this.getModuleRecurrenceTypeInfo()) {
      this.setState({
        anchorEl: event.currentTarget,
        openPopover: true
      });
    } else {
      this.setState({openDialog: true});
    }

  }

  handleCancel() {
    this.dialogCallbackYes = () => {
      // Remove temporal data
      firebase.database().ref(this.dbPath).set(null);
      this.setState({openDialog: false});
      this.handleClose();
    }
    this.dialogCallbackNo = () => {
      this.setState({openDialog: false});
    }
    this.setState({openDialog: true});
  }

  handleClose() {
    this.props.dispatch({
      type: 'UI_DIALOG',
      label: 'JOB_SCREEN',
      value: { }
    })
    // Call close photo screen dialog in case it's open.
    // The PhotoScreen dialog in this case is nested inside the JobScreen dialog.
    // When the JobScreen dialog is open and it's showing an image PhotoScreen,
    // hitting esc would close the JobScreen dialog without notifying the PhotoScreen dialog,
    // leading to unexpected behavior on subsequent operations.
    this.props.dispatch({
      type: 'UI_DIALOG',
      label: 'PHOTO_FULL_SCREEN',
      value: {
        imageUrl: "",
        imageDBPath: ""
      }
    })
  }

  requestClose() {
    if (this.isNewJob()) {
      this.handleCancel();
    } else {
      this.handleClose();
    }
  }

  deleteInstance() {
    FunctionUtils.deleteInstance(this.props.teamId,
      this.state.jobInfo, this.props.dateStr);
  }

  deleteFutureInstances() {
    FunctionUtils.changeDateModuleWithDates(
      this.props.teamId,
      this.state.jobInfo,
      this.state.jobInfo.modules.date.startDate,
      moment(this.props.dateStr).subtract(1, 'days').format('YYYY-MM-DD'));
  }

  deleteAllInstances() {
    FunctionUtils.deleteJob(this.props.teamId, this.state.jobInfo);
  }

  handleModuleSubtitleClicked = (moduleId) => {
    if (moduleId === 'lineItems') {
      this.setState({
        openLineItemsDetails: true
      })
    }
    if (moduleId === 'photos') {
      this.setState({
        openShowAllPhotosScreen: true
      })
    }
    if (moduleId === 'materials') {
      this.setState({
        openShowAllMaterialsScreen: true
      })
    }
    if (moduleId === 'notesExtended') {
      this.setState({
        openShowAllNotesScreen: true
      })
    }
  }

  handleLineItemsRequestClose = () => {
    this.setState({
      openLineItemsDetails: false
    })
  }

  handleShowAllPhotosScreenClose = () => {
    this.setState({
      openShowAllPhotosScreen: false
    })
  }

  handleShowAllMaterialsScreenClose = () => {
    this.setState({
      openShowAllMaterialsScreen: false
    })
  }

  handleShowAllNotesScreenClose = () => {
    this.setState({
      openShowAllNotesScreen: false
    })
  }

  addModule = (views, name, props) => {
    const moduleConfig = ModulesConfig[name]
    if (this.isNewJob() && moduleConfig.hideOnCreate) {
      return
    }
    const Module = moduleConfig.module
    const extendedProps = {...props, ...moduleConfig.props}
    if (views.length > 1) {
      views.push( <JobModulesDivider key={`${name}Divider`} showDivider={true} />)
    }
    views.push(
      <JobModuleCard
        key={name}
        moduleId={name}
        title={moduleConfig.title || props.title}
        subtitle={moduleConfig.subtitle}
        onSubtitleClicked={this.handleModuleSubtitleClicked}>
        <Module {...extendedProps} />
      </JobModuleCard>
    )
  }

  containsRemindersModule(){
    const found = this.modules.find(module => module === 'reminders')
    if (found){
      return true
    } else {
      return false
    }
  }

  renderModules() {
    const modulesViews = []
    modulesViews.push(<JobModulesDivider key='header' />)
    for (let i = 0; i < this.modules.length; i++) {
      if (this.modules[i] === 'contactInfo') {

        const parsedId = CustomerUtils.splitCustomerContactId(
          this.state.jobInfo.modules.contactInfo.customerContactId
        )

        this.addModule(modulesViews, this.modules[i], {
          jobInfo: this.state.jobInfo,
          customer: this.state.jobInfo.modules.contactInfo,
          contactId: parsedId.contactId,
          customerId: parsedId.customerId
        })
      }
      else
      if (this.modules[i] === 'displayName' || this.modules[i] === 'workers' || this.modules[i] === 'status') {
        this.addModule(modulesViews, this.modules[i], { jobInfo: this.state.jobInfo })
      }
      else
      if (this.modules[i] === 'date') {
        this.addModule(modulesViews, this.modules[i], { jobInfo: this.state.jobInfo, dateStr: this.props.dateStr })
      }
      else
      if (this.modules[i] === 'lineItems') {
        this.addModule(modulesViews, this.modules[i], {
          jobInfo: this.state.jobInfo,
          openLineItemsDetails: this.state.openLineItemsDetails,
          onRequestClose: this.handleLineItemsRequestClose
        })
      }
      else
      if (this.modules[i] === 'photos') {
        this.addModule(modulesViews, this.modules[i], {
          jobInfo: this.state.jobInfo,
          dateStr: this.props.dateStr,
          openShowAllPhotosScreen: this.state.openShowAllPhotosScreen,
          onRequestClose: this.handleShowAllPhotosScreenClose
        })
      }
      else
      if (this.modules[i] === 'materials') {
        this.addModule(modulesViews, this.modules[i], {
          jobInfo: this.state.jobInfo,
          dateStr: this.props.dateStr,
          openShowAllMaterialsScreen: this.state.openShowAllMaterialsScreen,
          onRequestClose: this.handleShowAllMaterialsScreenClose
        })
      }
      else
      if (this.modules[i] === 'notesExtended') {
        this.addModule(modulesViews, this.modules[i], {
          jobInfo: this.state.jobInfo,
          dateStr: this.props.dateStr,
          openShowAllNotesScreen: this.state.openShowAllNotesScreen,
          onRequestClose: this.handleShowAllNotesScreenClose
        })
      }
      else
      if (this.modules[i] === 'clockingExtended'
        || this.modules[i] === 'clockingWorker'
        || this.modules[i] === 'clockingLineItems') {
        this.addModule(modulesViews, this.modules[i], { jobInfo: this.state.jobInfo, dateStr: this.props.dateStr })
      }
      else
      if (this.modules[i] === 'assistants') {
        this.addModule(modulesViews, this.modules[i], {
          jobInfo: this.state.jobInfo,
          dbPath: this.extendedPath + '/modules/assistants/' + this.getDateStr()
        })
      }
      else
      if (this.modules[i] === 'laborers') {
        this.addModule(modulesViews, this.modules[i], { jobInfo: this.state.jobInfo, dbPath: this.dbPath + '/modules/laborers' })
      }
      else
      if (this.modules[i] === 'batchName') {
        this.addModule(modulesViews, this.modules[i], { jobInfo: this.state.jobInfo, dbPath: this.dbPath })
      }
      else
      if (this.modules[i] === 'clockingTeam') {
        this.addModule(modulesViews, this.modules[i], { jobInfo: this.state.jobInfo, dbPath: this.dbPath })
      }
      else
      if (this.modules[i] === 'notes') {
        this.addModule(modulesViews, this.modules[i], { jobInfo: this.state.jobInfo })
      }
      else
      if (this.modules[i] === 'notesTeam') {
        this.addModule(modulesViews, this.modules[i], { dbPath: this.dbPath + '/modules/notesTeam' })
      }
      if (this.modules[i] === 'sharedNotesTeam') {
        this.addModule(modulesViews, this.modules[i], { dbPath: this.extendedPath + '/modules/notesTeam/' + this.getDateStr() })
      }
      if (this.modules[i] === 'tasks') {
        this.addModule(modulesViews, this.modules[i], { jobInfo: this.state.jobInfo, dbPath: this.dbPath + '/modules/tasks' })
      }
      else
      if (this.modules[i] === 'sharedTasks') {
        this.addModule(modulesViews, this.modules[i], { jobInfo: this.state.jobInfo, dbPath: this.extendedPath + '/modules/tasks' })
      }
      else
      if (this.modules[i] === 'tasksRecurrent') {
        const doneDBPath = this.isNewJob()
          ? undefined
          : this.extendedPath + '/modules/tasksRecurrent/done/' + this.getDateStr()
        this.addModule(modulesViews, this.modules[i], {
          jobInfo: this.state.jobInfo,
          dbPath: this.dbPath + '/modules/tasksRecurrent',
          dateStr: this.getDateStr(),
          doneDBPath
        })
      }
      else
      if (this.modules[i] === 'tasksInstance') {
        this.addModule(modulesViews, this.modules[i], {
          jobInfo: this.state.jobInfo,
          title: `Tasks for ${moment(this.getDateStr()).format('MMM D')}`,
          dbPath: this.extendedPath + '/modules/tasksInstance/' + this.getDateStr(),
          enableReminders: this.containsRemindersModule(),
          dateStr: this.getDateStr()
        })
      }
    }
    modulesViews.push(<JobModulesDivider key='footer' />)
    return (
      <div>
        <Paper zDepth={1}>
          { modulesViews }
        </Paper>
      </div>
    )
  }

  renderDialog() {
    return (
      <Dialog
        actions={[
          <FlatButton
            key='no'
            label="No"
            primary={true}
            onTouchTap={() => this.dialogCallbackNo()} />,
          <FlatButton
            key='yes'
            label="Yes"
            primary={true}
            onTouchTap={() => this.dialogCallbackYes()} />
        ]}
        modal={false}
        open={this.state.openDialog}
        contentStyle={{maxWidth: 300}}
        title={'Are you sure?'}
        onRequestClose={() => this.dialogCallbackNo()}>
        {this.isNewJob()
          ? '' : 'This will delete the job and all information. You will not be able to retrieve deleted information.'}
      </Dialog>
    );
  }

  renderDelete() {
    return (
      <Popover
        open={this.state.openPopover}
        anchorEl={this.state.anchorEl}
        anchorOrigin={{horizontal: 'middle', vertical: 'bottom'}}
        targetOrigin={{horizontal: 'left', vertical: 'bottom'}}
        onRequestClose={() => this.setState({openPopover: false})}>
        <Menu>
          <MenuItem
            key={DELETE_INSTANCE}
            onTouchTap={() =>
              this.setState({
                deleteType: DELETE_INSTANCE,
                openPopover: false,
                openDialog: true
              })}
            primaryText={'Delete this instance'}/>
          <MenuItem
            key={DELETE_FUTURE}
            onTouchTap={() =>
              this.setState({
                deleteType: DELETE_FUTURE,
                openPopover: false,
                openDialog: true
              })}
            primaryText={'Delete future events'}/>
          <MenuItem
            key={DELETE_ALL}
            onTouchTap={() => this.setState({
              deleteType: DELETE_ALL,
              openPopover: false,
              openDialog: true
            })}
            primaryText={'Delete all events'}/>
        </Menu>
      </Popover>
    );
  }

  render() {
    
    if (!this.props.jobInfo || !this.state.jobInfo) {
      //dialog should not show
      return null
    }

    // List of actions
    let actions = [];
    if (this.isNewJob()) {
      actions.push(
        <FlatButton
          key='cancel'
          label='Cancel'
          primary={true}
          onTouchTap={this.handleCancel.bind(this)} />)
      actions.push(
        <FlatButton
          style={{backgroundColor: '#527da3'}}
          labelStyle={{color: 'white'}}
          key='create'
          label='Create'
          primary={true}
          onTouchTap={this.handleCreate.bind(this)} />)
    } else {
      actions.push(
        <FlatButton
          style={{backgroundColor: '#527da3'}}
          labelStyle={{color: 'white'}}
          key='done'
          label='Done'
          primary={true}
          onTouchTap={this.handleClose.bind(this)} />)
      actions.push(
        <FlatButton
          key='delete'
          label='Delete'
          primary={true}
          onTouchTap={(event) => this.handleDelete(event)} />)
    }

    if (this.state.isTablet) {
      const closeDialogHandler =
        this.state.isNewItem
          ? this.handleCancel.bind(this)
          : this.handleClose.bind(this);
      actions.push(
        <FlatButton
          style={closeDialogButtonStyle}
          primary={true}
          onTouchTap={closeDialogHandler}
          label='X' />)
    }

    let safeDisplayName = '';
    if (this.state.jobInfo.modules.displayName && this.state.jobInfo.modules.displayName.value) {
      safeDisplayName = this.state.jobInfo.modules.displayName.value;
    }

    if (this.state.jobInfo.modules.batchName) {
      safeDisplayName = "Batch Job Creation";
    }

    return (
      <div>
        <Dialog
          contentClassName="jobscreen-dialog-content"
          bodyClassName="jobscreen-dialog-body"
          contentStyle={this.state.isTablet ? tablet_contentStyle : desktop_contentStyle}
          style={this.state.isTablet ? tablet_dialogStyle : desktop_dialogStyle}
          actionsContainerStyle={this.state.isTablet ? tablet_actionsContainerStyle : desktop_actionsContainerStyle}
          bodyStyle={this.state.isTablet ? tablet_bodyStyle : desktop_bodyStyle}
          actions={actions}
          title={
            <Header
              title={safeDisplayName}
              onCloseClicked={this.requestClose.bind(this)} />
          }
          modal={false}
          open={true}
          repositionOnUpdate={false}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={true}
          onRequestClose={this.requestClose.bind(this)}>
          {
            this.state.loading
              ? (
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', margin: 22 }}>
                  <CircularProgress thickness={2} />
                </div>
              )
              :
              [
                this.renderModules(),
                this.getModuleRecurrenceTypeInfo() && this.renderDelete()
              ]
          }

        </Dialog>
        {this.renderDialog()}
      </div>
    );
  }
}

const headerStyle = {
  display: 'flex',
  displayDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: 80,
  backgroundColor: '#f7f7f7'
}

const headingStyle = {
  fontSize: 16,
  marginLeft: 32,
  color: '#212121'
}

const closeDialogButtonStyle = {
  position: 'fixed',
  top: 0,
  right: 0,
  margin: 10,
  height: 40
}

const desktop_dialogStyle = {
  paddingTop: 0,
  height: '100%',
  width: '100%',
  flexDirection: 'column'
}

const tablet_dialogStyle = {
  paddingTop: 0,
  height: '100%',
  width: '100%',
  flexDirection: 'column'
}

const desktop_bodyStyle = {
  backgroundColor: '#f7f7f7',
  padding: 0
}

const tablet_bodyStyle = {
  backgroundColor: '#f7f7f7',
  padding: 0,
  width: '100%'
}

const desktop_contentStyle = {
  width: '80%',
  borderRadius: 6,
  overflow: 'auto',
  maxWidth: 960
}

const tablet_contentStyle = {
  width: '100%',
  height: '100%',
  maxWidth: 'none',
  minHeight: 'none',
  transform: 'none',
  position: 'absolute'
}

const desktop_actionsContainerStyle = {
  display: 'flex',
  justifyContent: 'flex-start',
  marginTop: 0
}

const tablet_actionsContainerStyle = {
  display: 'flex',
  justifyContent: 'flex-start',
  marginTop: 0,
  border: 'none',
  height: 80,
  position: 'absolute',
  bottom: 0,
  left: 0,
  background: '#f7f7f7'
}

function mapStateToProps(state) {
  return Object.assign({
    teamId: state.firebase.team.metadata.value.id
  }, state.uiDialogs['JOB_SCREEN'])
}

export default connect(mapStateToProps)(JobScreen)



// WEBPACK FOOTER //
// ./src/schedule/common/JobScreen.js